export const capitalizeWords = (str: string) => {
  return str
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}

/** Backwards-compat alias for the old `capitalize` helper used across SEO sections. */
export const capitalize = capitalizeWords
